import { useIsStorefrontChannel } from '@/hooks/useIsStorefrontChannel';
import { selectStorefrontCustomization, selectPortalCustomizationsCustomization } from '@/redux/customizations/reducers';
import { useAppSelector } from '@/redux/hooks';

export function useActiveTheme(defaultTheme: 'dark' | 'light' | string = 'dark') {
  const isStorefront = useIsStorefrontChannel();
  const portal = useAppSelector(selectPortalCustomizationsCustomization);
  const storefront = useAppSelector(selectStorefrontCustomization);

  const theme = (isStorefront ? storefront?.tabs?.theme : portal?.tabs?.theme) ?? portal?.tabs?.theme ?? defaultTheme;

  const linkColor = (isStorefront ? storefront?.tabs?.link_color : portal?.tabs?.link_color) ?? portal?.tabs?.link_color;

  return { theme, linkColor };
}
